// extracted by mini-css-extract-plugin
module.exports = {"balanceWrapper":"BillingBalance_balanceWrapper__1S9Q8","balance":"BillingBalance_balance__3uwUD"};